import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_LOGIN } from '@/modules/login/router';
import { passwordService } from '@/services/password';
import { useVuelidate } from '@vuelidate/core';
import { email, required } from '@vuelidate/validators';
import { reactive } from 'vue';

export function useForgotPassword() {
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const model = reactive({
        email: ''
    });

    const validations = {
        email: { required, email }
    };

    const v$ = useVuelidate(validations, model);

    const actions = {
        submit: crudAction.executeAction({
            validator: v$,
            request: () => passwordService.generate(model.email),
            successMessage: 'Please check your mailbox',
            onSuccess: () => router.push({ name: ROUTE_NAME_LOGIN.INDEX })
        })
    };

    return { model, v$, actions };
}
